module.exports = __webpack_public_path__ + "img/orange-money.bde0765d.png";